import { computed, onMounted, openBlock, createElementBlock, normalizeClass, createElementVNode, createBlock, createCommentVNode, toDisplayString } from "vue";
import ErrorIcon from "../../uikit.icons/ErrorIcon.vue.es.js";
import WarningIcon from "../../uikit.icons/WarningIcon.vue.es.js";
import UikitCheckCircleIcon from "../../uikit.icons/CheckCircleIcon.vue.es.js";
import { useToastsStore } from "../../uikit.stores/toasts.es.js";
/* empty css              */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = { class: "icon" };
const _hoisted_2 = { class: "message" };
const _sfc_main = {
  __name: "Toast",
  props: {
    id: {
      type: String
    },
    message: {
      type: String,
      default: ""
    },
    timeout: {
      type: Number,
      default: 5
    },
    type: {
      type: String,
      default: "success",
      validator(value) {
        return ["success", "warning", "error", "info"].includes(value);
      }
    }
  },
  setup(__props) {
    const props = __props;
    const toastsStore = useToastsStore();
    const success = computed(() => props.type === "success");
    const warning = computed(() => props.type === "warning");
    const error = computed(() => props.type === "error");
    const info = computed(() => props.type === "info");
    const handleClickOnToast = () => {
      toastsStore.clearToast(props.id);
    };
    onMounted(() => {
      if (props.timeout > 0) {
        setTimeout(() => {
          toastsStore.clearToast(props.id);
        }, props.timeout * 1e3);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["uikit-toast", { warning: warning.value, error: error.value, info: info.value, success: success.value }]),
        onClick: handleClickOnToast
      }, [
        createElementVNode("div", _hoisted_1, [
          success.value ? (openBlock(), createBlock(UikitCheckCircleIcon, { key: 0 })) : createCommentVNode("", true),
          warning.value ? (openBlock(), createBlock(WarningIcon, { key: 1 })) : createCommentVNode("", true),
          error.value || info.value ? (openBlock(), createBlock(ErrorIcon, { key: 2 })) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_2, toDisplayString(__props.message), 1)
      ], 2);
    };
  }
};
const UikitToast = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-81268c94"]]);
export {
  UikitToast as default
};
//# sourceMappingURL=Toast.vue.es.js.map
